import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { ExpensesEntity } from './expenses.entity';
import { ExpensesController } from './expenses.controller';
import { ExpensesService } from './expenses.service';
import { ExpensesLogEntity } from './expensesLog.entity';


@Module({
  imports: [
    TypeOrmModule.forFeature([ExpensesEntity,ExpensesLogEntity]),
  ],
  controllers: [ExpensesController],
  providers: [ExpensesService, ApplicationExceptionHandler,LogsService]
})
export class ExpensesModule { }
